/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostProcessingPeriodMemoryForAnthropicPlatform extends models.BaseCostProcessingPeriodMemory {
    getFixupPrototypeFunction() { return CostProcessingPeriodMemoryForAnthropicPlatform.fixupPrototype; }

    static newInstance(model: Partial<CostProcessingPeriodMemoryForAnthropicPlatform>): CostProcessingPeriodMemoryForAnthropicPlatform {
        let obj = Object.assign(new CostProcessingPeriodMemoryForAnthropicPlatform(), model);
        CostProcessingPeriodMemoryForAnthropicPlatform.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostProcessingPeriodMemoryForAnthropicPlatform>): CostProcessingPeriodMemoryForAnthropicPlatform {
        if (!model) return null;
        return CostProcessingPeriodMemoryForAnthropicPlatform.newInstance(<CostProcessingPeriodMemoryForAnthropicPlatform> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostProcessingPeriodMemoryForAnthropicPlatform) {
        if (!obj) return;

        models.CostProcessingPeriodMemoryForAnthropicPlatform.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostProcessingPeriodMemoryForAnthropicPlatform): boolean {
        if (models.BaseCostProcessingPeriodMemory.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CostProcessingPeriodMemoryForAnthropicPlatform.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Digest of the Cost Report cells this period was last attributed from
     */
    content_digest: string;

}
